module.exports = __webpack_public_path__ + "static/img/button01en.7a0bf8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/button01en.png
// module id = RlGe
// module chunks = 1